<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-header>
        <mat-card-title>
            {{ 'ShareholderCategories.Title' | translate }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table class="table-check">
            <tr>
                <th></th>
                <th class="text-right">{{ 'Shareholders.TableTitle' | translate }}</th>
                <th class="text-right">{{ 'Shareholders.TotalShares' | translate }}</th>
            </tr>
            @for (item of items; track item) {
                <tr>
                    <td>
                        <b>{{ item.description }}</b>
                    </td>
                    <td class="text-right">
                        <b>{{ item.numberOfShareholders | slNumber }}</b>
                    </td>
                    <td class="text-right">
                        <b>{{ item.numberOfShares | slNumber }}</b>
                    </td>
                </tr>
                @if (item.children.length > 1) {
                    @for (child of item.children; track child) {
                        <tr>
                            <td class="pl-3">
                                @if (child.description) {
                                    <span>{{ child.description }}</span>
                                } @else {
                                    <span>{{ 'General.Others' | translate }}</span>
                                }
                            </td>
                            <td class="text-right">
                                {{ child.numberOfShareholders | slNumber }}
                            </td>
                            <td class="text-right">
                                {{ child.numberOfShares | slNumber }}
                            </td>
                        </tr>
                    }
                }
                <br />
            }
            <br />
            <tr>
                <td>
                    <b>{{ 'General.Total' | translate }}</b>
                </td>
                <td class="text-right">
                    <b>{{ totalShareholders | slNumber }}</b>
                </td>
                <td class="text-right">
                    <b>{{ totalShares | slNumber }}</b>
                </td>
            </tr>
        </table>
    </mat-card-content>
</mat-card>
